import { useState } from "react"

export const useBackofficeUpgradeRequestsList = () => {
	const [searchTerm, setSearchTerm] = useState<string>();
	
	const onSearchByTerm = async(value: string) => {
		setSearchTerm(value);
	}


	return {
		onSearchByTerm,
		state: {searchTerm}
	}
}